/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import $ from 'jquery'
import Cookies from 'js-cookie'
import 'slick-carousel'

const cookieName = (id) => `banner-${id}-closed`

function hideSlide($slide, $carousel) {
    $slide.addClass('is-dismissed')
    if ($carousel.hasClass('slick-initialized')) {
        const index = $carousel.find('.banner-carousel-slide').index($slide)
        if (index >= 0) {
            $carousel.slick('slickRemove', index)
        }
    }
}

/**
 * Initialise a `.banner-carousel` element with Slick. Wires close and link
 * behaviours; the video trigger is a data-frame-src modal (see Slide.html.twig).
 * Destroys the Slick instance and unbinds the handlers on disconnect.
 *
 * @type {Listener}
 */
export default {
    selector: '.banner-carousel',
    connect(element, { app }) {
        const $carousel = $(element)

        $carousel.find('.banner-carousel-slide').each(function () {
            const $slide = $(this)
            const id = $slide.data('bannerId')
            if (id && Cookies.get(cookieName(id))) {
                $slide.remove()
            }
        })

        const remaining = $carousel.find('.banner-carousel-slide').length
        if (remaining === 0) {
            // Self-removal is safe: the tracked entry is swept at the next unmount.
            $carousel.remove()
            return
        }

        if ($carousel.data('bannerCarousel') === true && remaining > 1 && !$carousel.hasClass('slick-initialized')) {
            $carousel.slick({
                arrows: true,
                dots: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                adaptiveHeight: true,
            })
        }

        $carousel.on('click.bannerCarousel', '.banner-carousel-close', function (e) {
            e.preventDefault()
            e.stopPropagation()

            const $slide = $(this).closest('.banner-carousel-slide')
            const id = $slide.data('bannerId')
            if (id) {
                Cookies.set(cookieName(id), 1)
            }
            hideSlide($slide, $slide.closest('.banner-carousel'))
        })

        $carousel.on('click.bannerCarousel', '.banner-carousel-slide.with-link', function (e) {
            if (
                $(e.target).closest('.banner-carousel-cta, .banner-carousel-close, .banner-carousel-video-trigger')
                    .length
            ) {
                return
            }

            const url = $(this).data('bannerUrl')
            if (!url) {
                return
            }
            const urlType = $(this).data('bannerUrlType')
            if (urlType === 'blank') {
                window.open(url, '_blank')
            } else {
                app.loadUrl(url)
            }
        })

        return () => {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick')
            }
            $carousel.off('.bannerCarousel')
        }
    },
}
